import styled from 'styled-components'
// components
import ChipOrigin from '@mui/material/Chip'
// themes
import { colors } from 'themes/index'

export const Intro = styled('div')`
  display: flex;
  align-items: baseline;
  gap: 16px;
  margin: 16px 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.darkBlue500};
`

export const DocsLink = styled('a')`
  margin-left: auto;
  color: ${colors.blue500};
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`

export const MonoCell = styled('span')`
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 13px;
  white-space: nowrap;
`

export const NoWrap = styled('span')`
  white-space: nowrap;
`

export const IpList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

// Keeps the row-actions column pinned to the right edge while the table scrolls
// horizontally. `display: contents` so it adds no layout box around the table.
export const StickyActions = styled('div')`
  display: contents;

  th {
    white-space: nowrap;
  }

  th:last-child,
  td:last-child {
    position: sticky;
    right: 0;
    background: ${colors.white100};
  }

  th:last-child {
    z-index: 4;
  }

  td:last-child {
    z-index: 1;
  }

  tr:hover td:last-child {
    background: ${colors.gray190};
  }
`

export const ScopeChips = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 320px;
`

export const ScopeChip = styled(ChipOrigin)`
  && {
    font-size: 10px;
  }

  .MuiChip-label {
    font-size: 10px;
  }
`

export const ScopeChipEntity = styled('span')`
  font-weight: 700;
  text-transform: uppercase;
`

export const ScopeChipActions = styled('span')`
  text-transform: uppercase;
`
